class QueueSearch {
    static DEFAULT_VALUE = {
        queue_group: {label: 'ปฏิบัติงาน/ชำนาญงาน/ปฏิบัติการ', value: 1},
        name: '',
        residence: { value: 1, label: "อาคารที่พักข้าราชการศาลยุติธรรม ขนาด 50 หน่วย (ตลิ่งชัน)" },
        queue_status_id: { value: 1, label: 'รอทำสัญญา' },
        search_all:false,
    }

    constructor(obj) {
        this.queue_group = obj.queue_group // level group
        this.name = obj.name
        this.residence = obj.residence
        this.queue_status_id = obj.queue_status
        this.search_all = obj.search_all
    }

    serialized() {
        const obj = {
            "queue_group_id": this.queue_group?.value || 0,
            "queue_status_id": this.queue_status_id?.value || 0
        }
        const residence_id = this.residence?.value || 1 // default = 1
        const query = Object.keys(obj).map(k => `${k}=${obj[k]}`).join('&')

        return `${residence_id}?${query}`
    }
}

export default QueueSearch